import { useEffect, useRef } from 'react';
import {
  Animated,
  Easing,
  View,
  StyleSheet
} from 'react-native';
import Svg, { Path } from 'react-native-svg';

const Spin = () => {
  const rotateAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const startRotation = () => {
      rotateAnim.setValue(0);
      Animated.timing(rotateAnim, {
        toValue: 1,
        duration: 1000,
        easing: Easing.linear,
        useNativeDriver: true,
      }).start(() => startRotation());
    };

    startRotation();

    return () => rotateAnim.stopAnimation();
  }, [rotateAnim]);

  const rotation = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });

  return (
    <View style={styles.wrapper}>
      <View style={styles.container}>
        <Animated.View style={{ transform: [{ rotate: rotation }] }}>
          <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
            <Path
              d="M12 8C14.2091 8 16 6.20914 16 4C16 1.79086 14.2091 0 12 0C9.79086 0 8 1.79086 8 4C8 6.20914 9.79086 8 12 8Z"
              fill="#1677FF"
              fillOpacity={0.6}
            />
            <Path
              d="M12 24C14.2091 24 16 22.2091 16 20C16 17.7909 14.2091 16 12 16C9.79086 16 8 17.7909 8 20C8 22.2091 9.79086 24 12 24Z"
              fill="#1677FF"
            />
            <Path
              d="M4 16C6.20914 16 8 14.2091 8 12C8 9.79086 6.20914 8 4 8C1.79086 8 0 9.79086 0 12C0 14.2091 1.79086 16 4 16Z"
              fill="#1677FF"
              fillOpacity={0.8}
            />
            <Path
              d="M20 16C22.2091 16 24 14.2091 24 12C24 9.79086 22.2091 8 20 8C17.7909 8 16 9.79086 16 12C16 14.2091 17.7909 16 20 16Z"
              fill="#1677FF"
              fillOpacity={0.4}
            />
          </Svg>
        </Animated.View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Spin;
